import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaRocket, FaCheckCircle, FaUsers, FaDownload } from 'react-icons/fa';
import HeaderActionButton from './HeaderActionButton';

/**
 * Cartouche Nodemented harmonisé avec le système unifié
 */
const NodementedTriggerBalanced = ({ 
  onClick, 
  disabled = false, 
  loading = false,
  nodes = []
}) => {
  const { t } = useTranslation();
  const hasNodes = nodes && nodes.length > 0;
  
  return (
    <HeaderActionButton 
      onClick={onClick}
      gradient="primary"
      disabled={disabled}
      loading={loading}
      className="nodemented-trigger"
    >
      <div className="button-header">
        <div className="button-icon"><FaRocket /></div>
        <div className="button-text-content">
          <h3 className="button-title">
            {hasNodes ? t('nodementedTriggerBalanced.titles.enhanced', { defaultValue: 'Nodemented+' }) : t('nodementedTriggerBalanced.titles.standard', { defaultValue: 'Nodemented' })}
          </h3>
          <p className="button-subtitle">
            {hasNodes ? t('nodementedTriggerBalanced.descriptions.enrich', { defaultValue: 'Enrichir votre graphe' }) : t('nodementedTriggerBalanced.descriptions.create', { defaultValue: 'Créer votre graphe' })}
          </p>
        </div>
        {!hasNodes && (
          <span className="button-badge">{t('nodementedTriggerBalanced.badges.new', { defaultValue: 'NOUVEAU' })}</span>
        )}
      </div>
      
      <div className="button-features">
        <div className="button-feature">
          <span>📥</span>
          <span>Create</span>
        </div>
        <div className="button-feature">
          <FaUsers />
          <span>Review</span>
        </div>
        <div className="button-feature">
          <FaCheckCircle />
          <span>Validation</span>
        </div>
        <div className="button-feature">
          <FaDownload />
          <span>Export</span>
        </div>
      </div>
      
      <div className="button-cta nodemented-trigger-cta">
        <span className="button-cta-text">
          <span className="cta-icon" style={{ marginRight: '8px', fontSize: '1.1em' }}>🚀✨</span>
          {hasNodes ? t('nodementedTriggerBalanced.buttons.enrich', { defaultValue: 'Enrichir mon graphe' }) : t('nodementedTriggerBalanced.buttons.start', { defaultValue: 'Démarrer le workflow' })}
        </span>
      </div>
    </HeaderActionButton>
  );
};

export default NodementedTriggerBalanced;